// One project scope for the whole client cabinet: picked in the sidebar,
// applied by every section (dashboard, «Від вас», payments). "all" = every
// project. Kept in localStorage as a per-viewer convenience only.
import { useEffect, useState } from "react";

const KEY = "client_project_scope";
const read = () => {
  try { return localStorage.getItem(KEY) || "all"; } catch (_) { return "all"; }
};
let current = read();
const subs = new Set();

export const setClientProject = (id) => {
  current = id || "all";
  try { localStorage.setItem(KEY, current); } catch (_) { /* private mode */ }
  subs.forEach((f) => f(current));
};

/** [scopeId, setScope]. Callers must treat an id that isn't one of the
 *  client's projects (stale from another account) as "all". */
export const useClientProject = () => {
  const [v, setV] = useState(current);
  useEffect(() => {
    subs.add(setV);
    return () => subs.delete(setV);
  }, []);
  return [v, setClientProject];
};

export const resolveScope = (scope, projects = []) =>
  scope && scope !== "all" && projects.some((p) => p.id === scope) ? scope : "all";
